// extracted by mini-css-extract-plugin
export default {"aglmd-inline-text-editor":"aZbdihiu1xex9fIJC5Nq","aglmd-inline-text-editor--default":"pHE7Wgt_rGwGUJmX1Uu_","aglmd-inline-text-editor--editing":"gma1dtOThVwcd2nj5CSQ"};